import { useCallback, useState } from 'react';
import { DormitoryLegacyHttp } from '@/services';
import { parseError } from '@/utils';

export default function useValidEntranceDormitory(defaultLoading: boolean = false) {
  const [validEntrance, setValidEntrance] = useState<DormitoryValidEntranceResponse>();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(defaultLoading);

  const fetchValidEntrance = useCallback(async () => {
    setLoading(true);
    try {
      const response = await DormitoryLegacyHttp.getValidEntranceDormitory();
      setValidEntrance(response.data?.payload);
    }
    catch(e) {
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { validEntrance, fetchValidEntrance, error, loading };
}
